import React from 'react';
import _ from 'lodash';
import type { BoxProps } from '@mui/material';
import { Typography, Box } from '@mui/material';
import TickedSlider from '../../customizeQuote/components/TickedSlider';
import { useGetAgencyDetails } from '../../hooks/useGetAgencyDetails';

interface UpdateCommissionResolverProps extends BoxProps {
  commissionInput: number | null | undefined;
  setCommissionInput: (input: number) => void | undefined;
  accountId: string;
}

const UpdateCommissionResolver = (props: UpdateCommissionResolverProps) => {
  const { data, isLoading, isError } = useGetAgencyDetails({
    accountId: props.accountId,
  });

  if (isLoading || isError) {
    return null;
  }

  return <UpdateCommission commission={data.commission} {...props} />;
};

interface UpdateCommissionProps extends UpdateCommissionResolverProps {
  commission: number;
}

const UpdateCommission = ({
  commission,
  commissionInput,
  setCommissionInput,
  ...props
}: UpdateCommissionProps) => {
  const handleSliderChange = _.debounce((newValue: number | number[]) => {
    setCommissionInput(newValue as number);
  }, 800);

  return (
    <Box display="flex" mt={0.5} alignItems="center" gap={2} {...props}>
      <Typography fontSize="1.2rem" minWidth="fit-content">
        Commission (
        {commissionInput ? Number(commissionInput).toFixed(2) : '0.00'}% of
        premium)
      </Typography>
      <TickedSlider
        boxProps={{
          alignItems: 'center',
          gap: '1rem',
          width: '14rem',
        }}
        min={0}
        max={commission}
        onChange={handleSliderChange}
        initialSliderValue={commissionInput as number}
      >
        {(value) => <Box fontSize="1.2rem">{Number(value).toFixed(2)}%</Box>}
      </TickedSlider>
    </Box>
  );
};

export default UpdateCommissionResolver;
